RecommendModalCtrl = ($scope, $modalInstance) ->
  $scope.cancel = ->
    $modalInstance.dismiss('cancel')

RecommendModalCtrl.$inject = [
  '$scope'
  '$modalInstance'
]

module.exports = RecommendModalCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/modal/recommend-modal-controller.coffee